/* global $ */
/* eslint-disable strict */

function passwordExists() {
  const password = $('#password');
  return !!password.val().trim();
}

function firstNameExists() {
  const firstName = $('#firstName');
  return !!firstName.val().trim();
}

function lastNameExists() {
  const lastName = $('#lastName');
  return !!lastName.val().trim();
}

function checkPasswordEquality() {
  const password = $('#password');
  const passwordConfirmation = $('#password-confirmation');
  return password.val() === passwordConfirmation.val();
}

function checkPasswordFulfillsMinimumSize() {
  const MIN_PASSWORD_LENGTH = 5;
  const password = $('#password');
  return password.val().length > MIN_PASSWORD_LENGTH;
}

function indicateMissingPassword() {
  const exists = passwordExists();
  const password = $('#password');
  if (exists) {
    password.removeClass('error');
  } else {
    password.addClass('error');
  }
}

function indicateMissingLastName() {
  const exists = lastNameExists();
  const lastName = $('#lastName');
  if (exists) {
    lastName.removeClass('error');
  } else {
    lastName.addClass('error');
  }
}

function indicateMissingFirstName() {
  const exists = firstNameExists();
  const firstName = $('#firstName');
  if (exists) {
    firstName.removeClass('error');
  } else {
    firstName.addClass('error');
  }
}

function indicateErroneousPassword() {
  const isPasswordValid = checkPasswordEquality() && checkPasswordFulfillsMinimumSize();
  const passwordConfirmation = $('#password-confirmation');

  if (isPasswordValid) {
    passwordConfirmation.removeClass('error');
  } else {
    passwordConfirmation.addClass('error');
  }
}

function activateAccountCreationButton() {
  const button = $('#create-account-button');
  const isPasswordValid = checkPasswordEquality() && checkPasswordFulfillsMinimumSize();
  const requiredFieldExists = firstNameExists() && lastNameExists();

  if (isPasswordValid && requiredFieldExists) {
    button.removeClass('is-disabled');
    button.prop('disabled', false);
  } else {
    button.addClass('is-disabled');
    button.prop('disabled', true);
  }
}

function toggleSubmitButton() {
  indicateErroneousPassword();
  indicateMissingFirstName();
  indicateMissingLastName();
  indicateMissingPassword();
  activateAccountCreationButton();
}

function showSpinner() {
  $('#loadingSpinner').append($('<span/>').addClass('mx-spinner-ring'));
}

function hideResetButton() {
  $('#create-account-button').hide();
}

$(() => {
  // Even though autofocus is used on this element, we must trigger it with
  // jQuery as well, so that Mixer can react to its being focused and add the
  // 'is-filled' class.
  $('#firstName').focus();
});

$('#toogle-password-visibility').click(() => {
  const passwordConfirmation = $('#password-confirmation');
  const type = passwordConfirmation.attr('type');

  if (type === 'text') {
    passwordConfirmation.attr('type', 'password');
  }
  if (type === 'password') {
    passwordConfirmation.attr('type', 'text');
  }
});

$('#password-confirmation').on('input', () => {
  toggleSubmitButton();
});

$('#password').on('input', () => {
  toggleSubmitButton();
});

$('#firstName').on('input', () => {
  toggleSubmitButton();
});

$('#lastName').on('input', () => {
  toggleSubmitButton();
});

$('#create-account-button').on('click', () => {
  hideResetButton();
  showSpinner();
});
